import { blocks } from '@yola/ws-sdk';
import get from 'lodash.get';
import {
  SURFACES,
  SURFACES_SECONDARY,
  SURFACES_PRIMARY,
} from 'src/js/modules/blocks/constants/display-options';

const isRecomendedSurfaceAllowable = (node, surfaces) => {
  const blockData = blocks.accessors.getBlockByElement(node);
  const surfaceList = surfaces.split(' ');

  const surfaceOptions = [SURFACES, SURFACES_PRIMARY];

  if (surfaceList.length > 1) {
    surfaceOptions.push(SURFACES_SECONDARY);
  }

  const displayOptions = get(blockData, 'availableSettings.displayOptions', []).filter(
    (option) => !option.hidden && surfaceOptions.includes(option.id)
  );

  return displayOptions.every((surfaceOption) => {
    const options = get(surfaceOption, 'options', []);
    if (!Number.isInteger(surfaceOption.index)) {
      return options.some((opt) => opt.value === surfaces);
    }
    return options.some((opt) => opt.value === surfaceList[surfaceOption.index]);
  });
};

export default isRecomendedSurfaceAllowable;
